import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export const GetAccountByIdService = (token, account_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const account = await axios.get(
        `${URL_AUTH}/api/brain/v1/admin/${account_id}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(account);
      resolve(account.data);
    } catch (error) {
      console.log("error:", error);
      reject(error);
    }
  });
};